import React, { useEffect } from 'react'
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { history } from '@/shared/history'
import { setIntl } from '@/store/lng'

const Layout = React.lazy(() => import('@/pages/layout'))
const Home = React.lazy(() => import('@/pages/home'))
const Intro = React.lazy(() => import('@/pages/intro'))
const Export = React.lazy(() => import('@/pages/export'))
const English = React.lazy(() => import('@/pages/english'))
const Ecobl = React.lazy(() => import('@/pages/products/ecobl'))
const EcoblTest = React.lazy(() => import('@/pages/products/ecobltest'))
const Qidongji = React.lazy(() => import('@/pages/products/qidongji'))
const Hejinmoju = React.lazy(() => import('@/pages/products/hejinmoju'))
const Tongbang = React.lazy(() => import('@/pages/products/tongbang'))
const Mugongjixie = React.lazy(() => import('@/pages/products/mugongjixie'))
const Hanqiejixie = React.lazy(() => import('@/pages/products/hanqiejixie'))
const OtherMachine = React.lazy(() => import('@/pages/products/other-machine'))
const Qipei = React.lazy(() => import('@/pages/products/qipei'))
const Mopei = React.lazy(() => import('@/pages/products/mopei'))
const TV = React.lazy(() => import('@/pages/products/tv'))
const TVBracket = React.lazy(() => import('@/pages/products/tvbracket'))
const Dianqi = React.lazy(() => import('@/pages/products/dianqi'))
const Dianlan = React.lazy(() => import('@/pages/products/dianlan'))
const Wujin = React.lazy(() => import('@/pages/products/wujin'))
const Fangzhipin = React.lazy(() => import('@/pages/products/fangzhipin'))
const Qitafangzhipin = React.lazy(() =>
  import('@/pages/products/qitafangzhipin'),
)
const Weishengjieju = React.lazy(() => import('@/pages/products/weishengjieju'))
const Jianzhucailiao = React.lazy(() =>
  import('@/pages/products/jianzhucailiao'),
)
const Xiangjiao = React.lazy(() => import('@/pages/products/xiangjiao'))
const Yiliao = React.lazy(() => import('@/pages/products/yiliao'))
const Muzhipin = React.lazy(() => import('@/pages/products/muzhipin'))
const Shipin = React.lazy(() => import('@/pages/products/shipin'))
const Iron = React.lazy(() => import('@/pages/products/iron'))

const MotoTricycle = React.lazy(() => import('@/pages/english/moto-tricycle'))
const Sprocket = React.lazy(() => import('@/pages/english/sprocket'))
const Gas = React.lazy(() => import('@/pages/english/gas'))
const Satellite = React.lazy(() => import('@/pages/english/satellite'))
const Electrical = React.lazy(() => import('@/pages/english/electrical'))
const Plastic = React.lazy(() => import('@/pages/english/plastic'))
const Aluminum = React.lazy(() => import('@/pages/english/aluminum'))
const Cable = React.lazy(() => import('@/pages/english/cable'))
const Carbon = React.lazy(() => import('@/pages/english/carbon'))
const Glassfiber = React.lazy(() => import('@/pages/english/glassfiber'))
const TopEight = React.lazy(() => import('@/pages/english/top-eight'))
const Summarization = React.lazy(() => import('@/pages/english/summarization'))
const Canton = React.lazy(() => import('@/pages/english/canton'))

function App() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  history.navigate = navigate
  history.location = location

  useEffect(() => {
    if (location.pathname.startsWith('/en')) {
      dispatch(setIntl('en'))
    } else {
      dispatch(setIntl('zh'))
    }
  }, [location.pathname])

  return (
    <Routes>
      <Route
        path='/'
        element={
          <React.Suspense fallback={<>...</>}>
            <Layout />
          </React.Suspense>
        }
      >
        <Route
          index
          element={
            <React.Suspense fallback={<>...</>}>
              <Home />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/intro'
          element={
            <React.Suspense fallback={<>...</>}>
              <Intro />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/export'
          element={
            <React.Suspense fallback={<>...</>}>
              <Export />
            </React.Suspense>
          }
        />
        <Route
          path='en'
          element={
            <React.Suspense fallback={<>...</>}>
              <English />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/ecobl'
          element={
            <React.Suspense fallback={<>...</>}>
              <Ecobl />
            </React.Suspense>
          }
        />
        <Route
          path='ecobltest'
          element={
            <React.Suspense fallback={<>...</>}>
              <EcoblTest />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/qdj'
          element={
            <React.Suspense fallback={<>...</>}>
              <Qidongji />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/mj'
          element={
            <React.Suspense fallback={<>...</>}>
              <Hejinmoju />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/tb'
          element={
            <React.Suspense fallback={<>...</>}>
              <Tongbang />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/mg'
          element={
            <React.Suspense fallback={<>...</>}>
              <Mugongjixie />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/hq'
          element={
            <React.Suspense fallback={<>...</>}>
              <Hanqiejixie />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/om'
          element={
            <React.Suspense fallback={<></>}>
              <OtherMachine />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/qp'
          element={
            <React.Suspense fallback={<></>}>
              <Qipei />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/mp'
          element={
            <React.Suspense fallback={<></>}>
              <Mopei />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/tv'
          element={
            <React.Suspense fallback={<></>}>
              <TV />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/tvb'
          element={
            <React.Suspense fallback={<></>}>
              <TVBracket />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/dq'
          element={
            <React.Suspense fallback={<></>}>
              <Dianqi />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/dl'
          element={
            <React.Suspense fallback={<></>}>
              <Dianlan />
            </React.Suspense>
          }
        />

        <Route
          path='/en?/wj'
          element={
            <React.Suspense fallback={<>...</>}>
              <Wujin />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/fzp'
          element={
            <React.Suspense fallback={<>...</>}>
              <Fangzhipin />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/qtfzp'
          element={
            <React.Suspense fallback={<>...</>}>
              <Qitafangzhipin />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/ws'
          element={
            <React.Suspense fallback={<>...</>}>
              <Weishengjieju />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/jz'
          element={
            <React.Suspense fallback={<>...</>}>
              <Jianzhucailiao />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/xj'
          element={
            <React.Suspense fallback={<>...</>}>
              <Xiangjiao />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/yl'
          element={
            <React.Suspense fallback={<>...</>}>
              <Yiliao />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/mzp'
          element={
            <React.Suspense fallback={<>...</>}>
              <Muzhipin />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/sp'
          element={
            <React.Suspense fallback={<>...</>}>
              <Shipin />
            </React.Suspense>
          }
        />
        <Route
          path='/en?/iron'
          element={
            <React.Suspense fallback={<>...</>}>
              <Iron />
            </React.Suspense>
          }
        />
        <Route
          path='/en/mc'
          element={
            <React.Suspense fallback={<>...</>}>
              <MotoTricycle />
            </React.Suspense>
          }
        />
        <Route
          path='/en/spt'
          element={
            <React.Suspense fallback={<>...</>}>
              <Sprocket />
            </React.Suspense>
          }
        />
        <Route
          path='/en/gas'
          element={
            <React.Suspense fallback={<>...</>}>
              <Gas />
            </React.Suspense>
          }
        />
        <Route
          path='/en/satellite'
          element={
            <React.Suspense fallback={<>...</>}>
              <Satellite />
            </React.Suspense>
          }
        />
        <Route
          path='/en/electrical'
          element={
            <React.Suspense fallback={<>...</>}>
              <Electrical />
            </React.Suspense>
          }
        />
        <Route
          path='/en/plastic'
          element={
            <React.Suspense fallback={<>...</>}>
              <Plastic />
            </React.Suspense>
          }
        />
        <Route
          path='/en/aluminum'
          element={
            <React.Suspense fallback={<>...</>}>
              <Aluminum />
            </React.Suspense>
          }
        />
        <Route
          path='/en/cable'
          element={
            <React.Suspense fallback={<>...</>}>
              <Cable />
            </React.Suspense>
          }
        />
        <Route
          path='/en/carbon'
          element={
            <React.Suspense fallback={<>...</>}>
              <Carbon />
            </React.Suspense>
          }
        />
        <Route
          path='/en/glassfiber'
          element={
            <React.Suspense fallback={<>...</>}>
              <Glassfiber />
            </React.Suspense>
          }
        />
        <Route
          path='/en/top'
          element={
            <React.Suspense fallback={<>...</>}>
              <TopEight />
            </React.Suspense>
          }
        />
        <Route
          path='/en/summarization'
          element={
            <React.Suspense fallback={<>...</>}>
              <Summarization />
            </React.Suspense>
          }
        />
        <Route
          path='/en/canton'
          element={
            <React.Suspense fallback={<>...</>}>
              <Canton />
            </React.Suspense>
          }
        />
      </Route>

      <Route path='*' element={<div>404</div>} />
    </Routes>
  )
}

export default App
